import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding-top: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  max-width: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  min-height: ", ";\n  padding: ", " ", " ", ";\n  text-align: center;\n\n  @media screen and ", " {\n    min-height: ", ";\n    padding: ", " ", " ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Card } from '@scp/ui-shared/components/Card';
import { Spacing } from '@scp/ui-shared/components/layout/Spacing';
import { Logo } from '@scp/ui-shared/components/brand/Logo';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { Paragraph } from '@scp/ui-shared/components/typography';
import { mediaQueryMobileMax } from '@scp/ui-shared/theme/responsive';
import { getE2eLabel } from './utils';
var E2E_TEXT_SUFFIX = '-infobox';
var Content = styled.div(_templateObject(), baselineToRem(110), baselineToRem(20), baselineToRem(12), baselineToRem(8), mediaQueryMobileMax, baselineToRem(125), baselineToRem(20), baselineToRem(8), baselineToRem(8));
var Wrapper = styled.div(_templateObject2(), baselineToRem(195));
var Inner = styled.div(_templateObject3(), baselineToRem(9));
var SubTitle = styled(Paragraph)(_templateObject4());

var renderSubTitle = function renderSubTitle(subTitle, subtitleDataE2e) {
  var isSubTitleString = typeof subTitle === 'string';

  if (isSubTitleString) {
    return React.createElement(SubTitle, {
      "data-e2e": getE2eLabel('subtitle', E2E_TEXT_SUFFIX, subtitleDataE2e)
    }, subTitle);
  }

  return subTitle;
};

export function InfoBox(_ref) {
  var title = _ref.title,
      titleDataE2e = _ref.titleDataE2e,
      subTitle = _ref.subTitle,
      subtitleDataE2e = _ref.subtitleDataE2e,
      children = _ref.children;
  var isTitleString = typeof title === 'string';
  return React.createElement(Wrapper, null, React.createElement(Card, {
    innerHorizontalMargin: 0,
    innerVerticalMargin: 0
  }, React.createElement(Content, null, React.createElement(Spacing, {
    marginBottom: 4
  }, React.createElement(Logo, {
    name: "scp-health-logo-text",
    width: baselineToRem(26),
    height: baselineToRem(17)
  })), isTitleString ? React.createElement(Paragraph, {
    as: "h2",
    "data-e2e": getE2eLabel('title', E2E_TEXT_SUFFIX, titleDataE2e)
  }, title) : title, !!subTitle && renderSubTitle(subTitle, subtitleDataE2e), React.createElement(Inner, null, children))));
}